import { AxiosError } from 'axios'
import { flow, makeObservable } from 'mobx'

import { STORE_UI } from 'Core/constants'
import { SortingParams } from 'Core/interfaces'
import { TableStore } from 'Core/stores/tableStore/TableStore'
import { storagePageSizeConstant } from 'Core/utils/storeHelpers/storagePageSizeConstant'

import { UrlParams } from 'Portals/Supplier/constants'
import { Document } from 'Portals/Supplier/entities'
import { getFilterConfig } from 'Portals/Supplier/Pages/Document/TableList/Filters/utils/config'
import { DocumentRepo } from 'Portals/Supplier/repositories'
import { RootStore } from 'Portals/Supplier/stores'

const STORAGE_DOCUMENT_PAGE_SIZE = storagePageSizeConstant('document')

export class DocumentTable extends TableStore<Document.Basic> {
	constructor(private rootStore: RootStore) {
		super(STORAGE_DOCUMENT_PAGE_SIZE)
	}

	@flow.bound
	*getItems(defaultSort?: SortingParams) {
		try {
			yield this.requestData({
				repository: DocumentRepo.getList,
				defaultSort
			})
		} catch (error) {
			this.rootStore[STORE_UI].showErrorNotification(error as AxiosError)
		}
	}

	initFromURLParams = (params: Record<string, string[]>) => {
		const filterKeys = [
			UrlParams.supplierLocationId,
			UrlParams.documentTypeId,
			UrlParams.status,
			UrlParams.showOnlySupplierDocuments
		]

		this.initFilterParamsFromUrl(params, filterKeys, getFilterConfig())
	}

	reset = () => {
		this.resetTable()
	}
}
